import axios from "axios";
import moment from "moment";
import "moment/locale/pt-br";
import React from "react";
import ReactDOM from "react-dom";
import config from "react-global-configuration";
import { connect, Provider } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { bindActionCreators } from "redux";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import configuration from "./conf";
import "./i18n";
import { authReducer } from "./reducers/authReducer";
import * as serviceWorker from "./serviceWorker";
import { persistor, store } from "./store";
import "./styles/css/index.css";

config.set(configuration);

// axios.defaults.headers.common = {
// 	"Content-Type": "application/json;charset=utf-8"
// };

axios.defaults.headers.post["Content-Type"] = "application/json";
moment.locale("pt-br");

const Index = (
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<App />
		</PersistGate>
	</Provider>
);

const mapDispatchToProps = (dispatch) =>
	bindActionCreators({ authReducer }, dispatch);

export default connect(mapDispatchToProps)(App);

ReactDOM.render(Index, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
